import PermissionsCustomView from "../../../gd/access-control/permissions/custom-view";
import {AddView_Group, AddView_GroupType} from "../../../gd-ui/add-view/@types";


export function addViewCheckAccess(structure:AddView_Group[]):AddView_Group[] {


    const availableViews = PermissionsCustomView.getAllAvailable()

    // filter out groups without items
    structure = _.filter(structure, (group:AddView_Group)=>{
        return group.type === AddView_GroupType.SEPARATOR || !_.isEmpty(group.items)
    })

    return _.map(structure, (group:AddView_Group)=>{
        if (group.type === AddView_GroupType.SEPARATOR) {
            return group
        }

        switch (group.id) {
            case 'dashboard':
                /*do nothing*/
                break

            default         :
                group.items = _.filter(group.items, (viewItem)=>availableViews.includes(viewItem?.typeId))
        }

        return group
    })







}